import type { CardBrand } from '@zeni/shared'

/**
 * カードブランドの表示名。各社の固有名詞なので翻訳せず、選択肢のラベルにもそのまま使う。
 */
export const CARD_BRAND_LABELS: Record<CardBrand, string> = {
  visa: 'VISA',
  mastercard: 'Mastercard',
  jcb: 'JCB',
  amex: 'American Express',
  diners: 'Diners Club',
  unionpay: 'UnionPay',
  discover: 'Discover',
}
